<!-- TODO: remove — temporary debug output of custom actions
<pre style="font-size: 11px; white-space: pre-wrap">DEBUG actions: {{ actions | json }}</pre>-->

@if (containerTitle && containerTitle.length > 0) {
  <div class="form-group o2m-fg">
    <label>{{ translationsService.translate(containerTitle) }}</label>
  </div>
}

@if (showAddNew() == true && addNewButtonOnTop) {
  <div class="manipulate-section-wrapper">
    @if (!checkForDisabled(getAttribute("name")) && isAddAvailable()) {
      <div
        class="manipulate-section right-sub-section-holder dataIsLinked listing-manipulate-section"
        (click)="addSection()"
      >
        <div class="icon-link-data repeater-icon"></div>
        @if (addNewTranslation) {
          <p class="repeater-text">
            {{ checkTranslation(addNewTranslation) }}
          </p>
        }
        @if (!addNewTranslation) {
          <p class="repeater-text">
            {{ checkTranslation("AddNew") }}
          </p>
        }
      </div>
    }
  </div>
}

@if (
  showAsListing &&
  !editInDialog &&
  gridSection &&
  !hideOneToManyItems &&
  inlineEdit == false &&
  !statisticsView
) {
  <div class="one-to-many-single-section listing-main-manipulate-section">
    <one-to-many-section
      [forwardEntities]="forwardEntities"
      [forwardEntityName]="forwardEntity"
      [bindingPropertyName]="bindingPropertyName"
      [number]="1"
      [deleteDisabled]="deleteDisabled"
      [hideRepeaterActionsCondition]="hideRepeaterActionsCondition"
      [contentTemplate]="contentTemplate"
      [actions]="actions"
      [(ngModel)]="gridSection"
      [parentBindingProp]="parentBindingProp"
      [section]="gridSection"
      (reorderEvent)="reorder($event)"
      (removeSectionEvent)="removeSection($event)"
      [orderEnabled]="orderEnabled"
      [orderProperty]="orderProperty"
    >
    </one-to-many-section>
  </div>
}

@if (
  showAsListing &&
  !editInDialog &&
  !gridSection &&
  !hideOneToManyItems &&
  inlineEdit == false &&
  !statisticsView
) {
  <p class="listing-select-item">Izberi vnos, ali dodaj novega</p>
}

@if (showAsListing && !hideOneToManyItems && inlineEdit == false) {
  <div class="grid-view-listing">
    <div class="FormSectionTitle GalisFormControl">
      <div
        class="SectionTitleControl"
        style="width: 100%; box-sizing: content-box"
      >
        <p class="frm-section">Vnosi</p>
      </div>
    </div>
    <table>
      <thead>
        <tr>
          <td>#</td>
          @for (lf of listingFields; track lf) {
            <td>
              {{ translationsService.translate(lf.Name) }}
            </td>
          }
          @if (!statisticsView) {
            <td class="o2m-actions"></td>
          }
        </tr>
      </thead>
      <tbody>
        @for (
          section of resolvePropertyBinding(
            model,
            bindingPropertyName,
            model.DurationYears
          );
          track section;
          let i = $index
        ) {
          <!-- ClientRowCssClass: client-only property a custom action's PostJS can set on the row (this.currentActionSection) -->
          <tr [ngClass]="section?.ClientRowCssClass">
            <td>{{ i + 1 }}</td>
            @for (lf of listingFields; track lf) {
              <td>
                @if (lf.DataType == "DateTime") {
                  <span>
                    {{
                      dfms.getValue(section, lf.Binding)
                        | date: "dd.MM.yyyy" : "CET"
                    }}
                  </span>
                }
                @if (
                  !lf.DataType ||
                  lf.DataType == "String" ||
                  lf.DataType.length == 0
                ) {
                  <span [class.underline_span]="dfms?.isFormReadOnly == true">
                    {{
                      checkValueTypeForDecimal(
                        dfms.getValue(section, lf.Binding)
                      )
                    }}
                  </span>
                }
                <!-- StringLink: same as String, but rendered as a link that opens the value in a new tab -->
                @if (
                  lf.DataType == "StringLink" &&
                  dfms.getValue(section, lf.Binding)
                ) {
                  <a
                    class="o2m-string-link"
                    [href]="getLinkHref(dfms.getValue(section, lf.Binding))"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="$event.stopPropagation()"
                  >
                    {{ dfms.getValue(section, lf.Binding) }}
                  </a>
                }
                @if (dfms?.isFormReadOnly == true) {
                  <a
                    class="search-redirect-a"
                    (click)="searchPageRedirect(section, lf)"
                  ></a>
                }
              </td>
            }
            @if (!statisticsView) {
              <td class="o2m-actions">
                @if (!hideEditIcon) {
                  <a class="btn btn-default btn-sm"
                    ><span
                      class="ti-icon ti-edit"
                      (click)="inEditSection(i, section)"
                    ></span
                  ></a>
                }
                @if (
                  dfms?.isFormReadOnly != true &&
                  !checkForDisabled(getAttribute("name"))
                ) {
                  <a class="btn btn-default btn-sm" (click)="inRemoveSection(i, section)"
                    ><span class="ti-icon ti-trash"></span
                  ></a>
                }
                @for (action of actions; track action) {
                  <div>
                    @if (
                      (!action.Condition ||
                        evaluateCondition(action.Condition)) &&
                      dfms?.isFormReadOnly != true
                    ) {
                      @if (action.Icon) {
                        <!-- Custom action rendered as an icon button (same markup as Edit/Delete) -->
                        <a
                          class="btn btn-default btn-sm"
                          [title]="translationsService.translate(action.ActionName)"
                          (click)="evaluateRowAction(action, section, i)"
                          ><span class="ti-icon" [ngClass]="action.Icon"></span
                        ></a>
                      } @else {
                        <div
                          (click)="evaluateRowAction(action, section, i)"
                          class="dd-section"
                        >
                          <p class="repeater-text">
                            {{
                              this.translationsService.translate(
                                action.ActionName
                              )
                            }}
                          </p>
                        </div>
                      }
                    }
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
      <tfoot></tfoot>
    </table>
  </div>
}

<!--|| (presentTableLayoutInReadonly == true && dfms?.isFormReadOnly == true)-->
@if (
  ((!showAsListing &&
    !hideOneToManyItems &&
    inlineEdit == false &&
    dfms?.isFormReadOnly == false) ||
    (dfms?.isFormReadOnly == true && inlineEdit == false)) &&
  contentTemplate
) {
  <div>
    @for (
      section of resolvePropertyBinding(
        model,
        bindingPropertyName,
        model.DurationYears
      );
      track section;
      let i = $index
    ) {
      <div class="one-to-many-section-wrapper">
        @if (indexingEnabled == true) {
          <div class="o2m-numbering">
            <p>{{ i + 1 }}. {{ indexingPrefix }}</p>
          </div>
        }
        <one-to-many-section
          [forwardEntities]="forwardEntities"
          [forwardEntityName]="forwardEntity"
          [bindingPropertyName]="bindingPropertyName"
          [hideRepeaterActionsCondition]="hideRepeaterActionsCondition"
          [number]="i"
          [contentTemplate]="contentTemplate"
          [actions]="actions"
          [section]="section"
          [deleteDisabled]="deleteDisabled"
          (removeSectionEvent)="removeSection($event)"
          (reorderEvent)="reorder($event)"
          [parentBindingProp]="parentBindingProp"
          [orderEnabled]="orderEnabled"
          [orderProperty]="orderProperty"
          [nestedRenderUrl]="nestedRenderUrl"
          [listingFields]="listingFields"
        ></one-to-many-section>
        <!--<div *ngIf="hideNewAddSection == false && !checkForDisabled(bindingPropertyName)" class="bottom-action">
        <div class="manipulate-section right-sub-section-holder dataIsLinked" (click)="addSection()"
          *ngIf="!checkForDisabled(getAttribute('name'))">
          <div class="icon-link-data repeater-icon"></div>
          <p class="repeater-text">
            {{checkTranslation('AddNew')}}
          </p>
        </div>
      </div>-->
      </div>
    }
  </div>
}

@if (!showAsListing && !hideOneToManyItems && inlineEdit == true) {
  <div
    class="grid-view-listing inline-edit"
    [ngClass]="{
      'readonly-table-layout':
        presentTableLayoutInReadonly == true && dfms?.isFormReadOnly == true,
    }"
  >
    <!--div class="FormSectionTitle GalisFormControl ">
    <div class="SectionTitleControl" style="width:100%;box-sizing:content-box;">
      <p class="frm-section ">Vnosi</p>
    </div>
  </div-->
    <table>
      <thead>
        <tr>
          @if (dfms?.isFormReadOnly != true) {
            <td>#</td>
          }
          @for (lf of listingFields; track lf) {
            <td>
              {{ translationsService.translate(lf.Name) }}
            </td>
          }
          @if (showRepeaterActions()) {
            <td class="o2m-actions"></td>
          }
        </tr>
      </thead>
      <tbody>
        @for (
          section of resolvePropertyBinding(
            model,
            bindingPropertyName,
            model.DurationYears
          );
          track section;
          let i = $index
        ) {
          <!-- ClientRowCssClass: client-only property a custom action's PostJS can set on the row (this.currentActionSection) -->
          <!-- EnableClickOnRow: a click on the row opens enableClickOnRowRedirectUrl + section.Id in a new tab -->
          <tr
            [ngClass]="section?.ClientRowCssClass"
            [class.o2m-row-clickable]="isRowClickable(section)"
            (click)="onRowClick($event, section)"
          >
            @if (dfms?.isFormReadOnly != true) {
              <td>{{ i + 1 }}</td>
            }
            @for (lf of listingFields; track lf) {
              <td>
                @if (lf.DataType == "DateTime") {
                  <span>
                    {{
                      dfms.getValue(section, lf.Binding)
                        | date: "dd.MM.yyyy" : "CET"
                    }}
                  </span>
                }
                @if (
                  !lf.DataType ||
                  lf.DataType == "String" ||
                  lf.DataType.length == 0
                ) {
                  <span [class.underline_span]="dfms?.isFormReadOnly == true">
                    {{
                      dfms
                        .getValue(section, lf.Binding)
                        ?.toLocaleString("sl-SI")
                    }}
                  </span>
                }
                <!-- StringLink: same as String, but rendered as a link that opens the value in a new tab -->
                @if (
                  lf.DataType == "StringLink" &&
                  dfms.getValue(section, lf.Binding)
                ) {
                  <a
                    class="o2m-string-link"
                    [href]="getLinkHref(dfms.getValue(section, lf.Binding))"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="$event.stopPropagation()"
                  >
                    {{ dfms.getValue(section, lf.Binding) }}
                  </a>
                }
                @if (!lf.DataType || lf.DataType == "Currency") {
                  <input
                    [ngModel]="dfms.getValue(section, lf.Binding)"
                    [disabled]="true"
                    class="tb-table-o2m"
                    [class.underline_span]="dfms?.isFormReadOnly == true"
                    [currencyMask]="{
                      align: 'left',
                      allowNegative: false,
                      precision: 2,
                      min: 0,
                      inputMode: Natural,
                      prefix: '',
                      suffix: ' €',
                      thousands: '.',
                      decimal: ',',
                    }"
                  />
                }
                <!-- the overlay anchor covers the row, so it is left out when the row click redirect is active -->
                @if (dfms?.isFormReadOnly == true && !isRowClickable(section)) {
                  <a
                    class="search-redirect-a"
                    (click)="searchPageRedirect(section, lf)"
                  ></a>
                }
              </td>
            }
            @if (showRepeaterActions()) {
              <td class="o2m-actions o2m-row-actions">
                @if (!hideEditIcon) {
                  <a class="btn btn-default btn-sm"
                    ><span
                      class="ti-icon ti-edit"
                      (click)="inEditSection(i, section)"
                    ></span
                  ></a>
                }
                @if (dfms?.isFormReadOnly != true && deleteDisabled != true) {
                  <a class="btn btn-default btn-sm" (click)="inRemoveSection(i, section)"
                    ><span class="ti-icon ti-trash"></span
                  ></a>
                }
                @for (action of actions; track action) {
                  <div>
                    @if (
                      (!action.Condition ||
                        evaluateCondition(action.Condition)) &&
                      dfms?.isFormReadOnly != true
                    ) {
                      @if (action.Icon) {
                        <!-- Custom action rendered as an icon button (same markup as Edit/Delete) -->
                        <a
                          class="btn btn-default btn-sm"
                          [title]="translationsService.translate(action.ActionName)"
                          (click)="evaluateRowAction(action, section, i)"
                          ><span class="ti-icon" [ngClass]="action.Icon"></span
                        ></a>
                      } @else {
                        <div
                          (click)="evaluateRowAction(action, section, i)"
                          class="dd-section"
                        >
                          <p class="repeater-text">
                            {{
                              this.translationsService.translate(
                                action.ActionName
                              )
                            }}
                          </p>
                        </div>
                      }
                    }
                  </div>
                }
              </td>
            }
          </tr>
          @if (inEditMode && i == selectedIndex && listingFields) {
            <tr>
              <td [attr.colspan]="listingFields.length + 2">
                <one-to-many-section
                  [forwardEntityName]="forwardEntity"
                  [forwardEntities]="forwardEntities"
                  [hideRepeaterActionsCondition]="hideRepeaterActionsCondition"
                  [bindingPropertyName]="bindingPropertyName"
                  [number]="1"
                  [contentTemplate]="contentTemplate"
                  [actions]="actions"
                  [parentBindingProp]="parentBindingProp"
                  [isInline]="inlineEdit"
                  [section]="gridSection"
                  (reorderEvent)="reorder($event)"
                  (removeSectionEvent)="removeSection($event)"
                  [deleteDisabled]="deleteDisabled"
                  [orderEnabled]="orderEnabled"
                  [orderProperty]="orderProperty"
                ></one-to-many-section>
              </td>
            </tr>
          }
        }
      </tbody>
      <tfoot></tfoot>
    </table>
  </div>
}

@if (showAddNew() == true && !addNewButtonOnTop) {
  <div class="manipulate-section-wrapper">
    @if (!checkForDisabled(getAttribute("name")) && isAddAvailable()) {
      <div
        class="manipulate-section right-sub-section-holder dataIsLinked listing-manipulate-section"
        (click)="addSection()"
      >
        <div class="icon-link-data repeater-icon"></div>
        @if (addNewTranslation) {
          <p class="repeater-text">
            {{ checkTranslation(addNewTranslation) }}
          </p>
        }
        @if (!addNewTranslation) {
          <p class="repeater-text">
            {{ checkTranslation("AddNew") }}
          </p>
        }
      </div>
    }
  </div>
}

@if (showCustomAdditionalDataFields) {
  <div class="additional-custom-data">
    @for (additionalField of additionalFields; track additionalField) {
      <div class="additional-custom-data-item">
        @if (additionalFieldVisibility(additionalField) == true) {
          <div class="form-group">
            <label class="sem-control-label">
              @if (additionalField.Mandatory) {
                <span>* </span>
              }
              {{ checkTranslation(additionalField.Label) }}</label
            >
            <!--[semrequired]="additionalField.Mandatory ? 'AdditionalFieldsData.stdresa' : null" for test-->
            @if (
              additionalField.Type == "string" ||
              additionalField.Type == "numeric"
            ) {
              <sem-text-box
                [isPasswordInput]="false"
                [isNumberInput]="additionalField.Type == 'numeric'"
                [form]="form"
                (ngModelChange)="setProp(additionalField.Binding, $event)"
                [ngModel]="getProp(model, additionalField.Binding)"
                [isReadOnly]="false"
                name="additionalField.Binding"
              >
              </sem-text-box>
            }
            @if (additionalField.Type == "date") {
              <sem-date-picker
                [form]="form"
                [ngModel]="getProp(model, additionalField.Binding)"
                (ngModelChange)="setProp(additionalField.Binding, $event)"
                name="additionalField.Binding"
                date-format="DD/MM/YYYY"
                [templateType]="'calendar_month'"
                [isReadOnly]="false"
              ></sem-date-picker>
            }
            @if (additionalField.Type == "registry") {
              <sem-drop-down-select
                class="sem-drop-down-additional-custom-data-item"
                [minWidth]="minWidth"
                [form]="form"
                [filterField]="'Title'"
                [titleField]="'Title'"
                [parent]="guid"
                [galregistryname]="additionalField.LinkedEntity"
                [ngModel]="getProp(model, additionalField.Binding)"
                (ngModelChange)="setProp(additionalField.Binding, $event)"
                [subBindingPropertyName]="''"
                [preLoad]="true"
                (itemSelected)="ddItemSelected($event)"
                [isReadOnly]="false"
                name="{{ additionalField.Binding }}"
                [type]="1"
                [multiFieldRootPropertyBinding]="''"
                [waitForFilteredValue]="false"
                [filteredValueBinding]="''"
              >
              </sem-drop-down-select>
            }
            @if (additionalField.Type == "bool") {
              <sem-check-box
                [form]="form"
                [isReadOnly]="false"
                [ngModel]="getProp(model, additionalField.Binding)"
                (ngModelChange)="setProp(additionalField.Binding, $event)"
                name="{{ additionalField.Binding }}"
              >
              </sem-check-box>
            }
          </div>
        }
      </div>
    }
  </div>
}
